import React from 'react';
import DashboardContext from '../dashboards/DashboardContext';
import ChartContext from './ChartContext';
import { API } from '../API';
import PropTypes from 'prop-types';

const ChartContainer = ({ children }) => {
  const dashCtx = React.useContext(DashboardContext);
 
  const [charts, setCharts] = React.useState([]);
  const [dateFilter, setDateFilter] = React.useState('today');
  const [subFilter, setSubFilter] = React.useState(null);
  const [subIdFilter, setSubIdFilter] = React.useState(null);
  
  React.useEffect(() => {
    if (dashCtx.selectedDashboard) {
      API.get(
        '/get?dashboard=' +
          dashCtx.selectedDashboard
      )
        .then((res) => {
          setSubFilter(dashCtx.selectedSubscriberKey);
          setCharts(res.data.charts);
        })
        .catch((err) => console.log(err));
    }
  }, [dashCtx.selectedDashboard, dashCtx.selectedSubscriberKey]);

  return (
    <ChartContext.Provider
      value={{
        charts,
        dateFilter,
        setDateFilter,
        subFilter,
        setSubFilter,
        subIdFilter,
        setSubIdFilter,
      }}
    >
      {children}
    </ChartContext.Provider>
  );
};

ChartContainer.propTypes = {
  children: PropTypes.any,
};

export default ChartContainer;
